import { gql } from '@apollo/client';

export const CreateBoardMutation = gql`
  mutation CreateBoardMutation(
    $name: String
    $profileIds: [ID!]
    $masterAccountIds: [ID!]
    $userIds: [ID!]
    $groupIds: [ID!]
    $settings: Json
    $locationFilter: LocationFilterInput
    $returnGigsSetting: Int
    $showFirstAndLastName: Boolean
    $textlineGroupUuid: String
    $labels: [String!]
  ) {
    createBoard(
      board: {
        name: $name
        settings: $settings
        profileIds: $profileIds
        masterAccountIds: $masterAccountIds
        userIds: $userIds
        groupIds: $groupIds
        locationFilter: $locationFilter
        returnGigsSetting: $returnGigsSetting
        showFirstAndLastName: $showFirstAndLastName
        textlineGroupUuid: $textlineGroupUuid
        labels: $labels
      }
    ) {
      board {
        id
        name
      }
    }
  }
`;
